<template>
    <div>
        <div class="mb-8"></div>
        <section class="flex flex-col-reverse md:flex-row container mx-auto">
            <!-- Image -->
            <div class="flex w-full md:w-3/5 items-center mx-auto">
                <img
                    alt="logo"
                    class="w-full"
                    :src="$S3AssetUrl('suf/profile/register-user.jpg')"
                />
            </div>

            <!-- Register Form -->
            <div class="flex flex-col w-full md:w-2/5 mx-auto px-4">
                <h2 class="py-2 text-2xl font-bold">
                    {{ $t("Forms.i_want_new_user") }}
                </h2>
                <p class="mb-4">
                    {{ $t("Forms.i_want_new_user_description") }}
                </p>
                <p class="mb-4">
                    {{ $t("Forms.if_you_have_account") }}
                    <router-link
                        :to="{ name: 'login' }"
                        class="cursor-pointer text-newxcaret-blue"
                    >
                        {{ $t("Forms.login") }}
                    </router-link>
                </p>

                <ValidationObserver v-slot="{ handleSubmit }">
                    <form
                        @submit.prevent="handleSubmit(register)"
                        class="flex flex-col w-full pt-2 pb-6 relative"
                    >
                        <div class="flex -mx-2">
                            <div class="w-1/2 mx-2 mb-2">
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                >
                                    <!-- Nombre -->
                                    <label
                                        class="font-bold"
                                        :for="$t('Forms.firstname')"
                                        >{{ $t("Forms.firstname") }}</label
                                    >
                                    <input
                                        type="text"
                                        v-model="formRegister.FirstName"
                                        :placeholder="$t('Forms.firstname')"
                                        :name="$t('Forms.firstname')"
                                        :class="[
                                            errors.length &&
                                                'border-newxcaret-red',
                                        ]"
                                        class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg text-grey"
                                    />
                                    <p
                                        class="txt-error text-red text-xs italic"
                                    >
                                        {{ errors[0] }}
                                    </p>
                                </ValidationProvider>
                            </div>

                            <div class="w-1/2 mx-2 mb-2">
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                >
                                    <!-- Apellidos -->
                                    <label
                                        class="font-bold"
                                        :for="$t('Forms.lastname')"
                                        >{{ $t("Forms.lastname") }}</label
                                    >
                                    <input
                                        type="text"
                                        v-model="formRegister.LastName"
                                        :placeholder="$t('Forms.lastname')"
                                        :name="$t('Forms.lastname')"
                                        :class="[
                                            errors.length &&
                                                'border-newxcaret-red',
                                        ]"
                                        class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg text-grey"
                                    />
                                    <p
                                        class="txt-error text-red text-xs italic"
                                    >
                                        {{ errors[0] }}
                                    </p>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="w-full mb-2">
                            <ValidationProvider
                                rules="required|email"
                                v-slot="{ errors }"
                            >
                                <!-- Correo Electronico -->
                                <label
                                    class="font-bold"
                                    :for="$t('Forms.email')"
                                    >{{ $t("Forms.email") }}</label
                                >
                                <input
                                    type="email"
                                    v-model="formRegister.Email"
                                    :class="[
                                        errors.length && 'border-newxcaret-red',
                                    ]"
                                    :placeholder="$t('Forms.email')"
                                    :name="$t('Forms.email')"
                                    class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg text-grey"
                                />
                                <p class="txt-error text-red text-xs italic">
                                    {{ errors[0] }}
                                </p>
                            </ValidationProvider>

                            <p
                                class="txt-error text-red text-xs italic"
                                v-if="errorLogin.email"
                            >
                                {{ responseErrors.Email[0] }}
                            </p>
                        </div>

                        <!-- Teléfono -->
                        <!-- <input
                type="text"
                :placeholder="t.Forms.phone"
                class="
                  w-1/2
                  h-10
                  p-3
                  my-2
                  mx-2
                  border border-newxcaret-blue
                  bg-white
                  rounded-lg
                  text-grey
                "
              /> -->

                        <div class="flex -mx-2">
                            <div class="w-1/2 mx-2">
                                <div class="w-full mb-2">
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        vid="confirmation"
                                    >
                                        <label
                                            class="font-bold"
                                            :for="$t('Forms.new_password')"
                                            >{{
                                                $t("Forms.new_password")
                                            }}</label
                                        >
                                        <input
                                            type="password"
                                            :id="$t('Forms.new_password')"
                                            :name="$t('Forms.new_password')"
                                            v-model="formRegister.Password"
                                            :class="[
                                                errors.length &&
                                                    'border-newxcaret-red',
                                            ]"
                                            @keyup="
                                                validatePassword(
                                                    $event.target.value
                                                )
                                            "
                                            class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg text-grey"
                                        />
                                        <p
                                            class="txt-error text-red text-xs italic"
                                        >
                                            {{ errors[0] }}
                                        </p>
                                    </ValidationProvider>
                                </div>

                                <ValidationProvider
                                    rules="required|confirmed:confirmation"
                                    v-slot="{ errors }"
                                >
                                    <label
                                        class="font-bold"
                                        :for="$t('Forms.confirmation_password')"
                                        >{{
                                            $t("Forms.confirmation_password")
                                        }}</label
                                    >
                                    <input
                                        type="password"
                                        v-model="
                                            formRegister.ConfirmationPassword
                                        "
                                        :id="$t('Forms.confirmation_password')"
                                        :name="
                                            $t('Forms.confirmation_password')
                                        "
                                        :placeholder="
                                            $t('Forms.confirmation_password')
                                        "
                                        :class="[
                                            errors.length &&
                                                'border-newxcaret-red',
                                        ]"
                                        class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg text-grey"
                                    />
                                    <p
                                        class="txt-error text-red text-xs italic"
                                    >
                                        {{ errors[0] }}
                                    </p>
                                </ValidationProvider>
                            </div>

                            <div
                                class="w-1/2 text-xs mx-2"
                                v-if="errorLogin.password"
                            >
                                <p>Tu contraseña debe tener:</p>
                                <ul class="list-disc ml-4">
                                    <li
                                        v-for="(
                                            item, index
                                        ) in responseErrors.Password"
                                        :key="index"
                                    >
                                        {{ item.msg }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- <div class="flex -mx-2">
              <div class="w-1/2 text-xs mx-2" v-if="errorLogin.password">
                <p>{{ t.Forms.password_rules }}</p>
                <ul class="list-disc ml-4">
                  <li
                    v-for="(item, index) in responseErrors.Password"
                    :key="index"
                    class="text-red italic"
                  >
                    {{ item.msg }}
                  </li>
                </ul>
              </div>
            </div> -->

                        <div class="flex -mx-2">
                            <!-- País -->
                            <!-- <select
                class="
                  w-1/2
                  h-10
                  p-3
                  my-2
                  mx-2
                  border border-newxcaret-blue
                  bg-white
                  rounded-lg
                  text-grey
                "
              >
                <option selected="selected" disabled="disabled">
                  {{ t.Forms.country }}*
                </option>
                <option value="">México</option>
                <option value="">Argentina</option>
              </select> -->
                        </div>

                        <br /><br />

                        <p
                            class="txt-error text-red text-xs italic"
                            v-if="msgApi.error"
                        >
                            {{ msgApi.message }}
                        </p>

                        <p
                            class="text-green-xcaret text-xs italic"
                            v-if="msgApi.success"
                        >
                            {{ msgApi.message }}
                        </p>

                        <!-- <div class="my-4">
            <div class="ml-4 text-sm">
              <input class="-ml-4" id="checkRecieve" type="checkbox" />
              <label for="checkRecieve" class="ml-1 text-grey">{{
                t.Forms.receive_information_promotions
              }}</label>
            </div>
            <div class="ml-4 text-sm">
              <input class="-ml-4" id="checkLegal" type="checkbox" />
              <label for="checkLegal" class="ml-1 text-grey">{{
                t.Forms.legal_age
              }}</label>
            </div>
          </div> -->
                        <div class="flex flex-col md:flex-row mt-4">
                            <!-- <vue-recaptcha
              sitekey="6LcJoMYSAAAAAG45yRuDtmL8WW-gbobYG7b-UBVc"
            ></vue-recaptcha> -->
                            <button
                                type="submit"
                                class="flex items-center justify-center w-full mt-4 md:mx-2 md:my-auto p-2 bg-yellow-photo rounded-full text-sm font-semibold"
                            >
                                {{ $t("Forms.create_account") }}
                            </button>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </section>
    </div>
</template>

<script>
import "../validators/index";
import methodUser from "../mixins/methodUser";

import Users from "../mixins/Users";
import SearchPackage from "../photo/searchPackageComponent";
import loginData from "../logic/profile/login";
import registerData from "../logic/profile/register";
import activateNewUserData from "../logic/profile/activateNewUser";
import recoveryPasswordData from "../logic/profile/recoveryPassword";
import validatePasswordData from "../logic/profile/validatePassword";

export default {
    props: [],
    mixins: [methodUser, Users],
    components: {
        SearchPackage
    },
    data: () => ({
        user: {},
        pathname: window.location.origin + "/",
        BirthdateInput: { name: "Birthdate" },
        loading: false,
        formLogin: {
            Username: "",
            Password: "",
        },
        formRegister: {
            Password: "", //*
            Email: "", //example@email.com
            FirstName: "", //test
            LastName: "", //test
            Phone: "",
            Birthdate: "", //31/12/1982
            Locale: "", //Mexico
            Gender: "", //Masculino
            Title: "", //Sr.
        },
        formActiveNewUser: {
            Email: "", //example@email.com
            Code: "",
            helperBtnSend: true,
        },
        formResetPassword: {
            Email: "", //example@email.com
            Code: "",
            Password: "",
            helperBtnSend: true,
        },
        formRecoveryPass: {
            Email: "",
        },
    }),
    watch: {
        activeForm: function () {
            this.errorLogin.statusApiMessage = false;
            this.msgApi.success = false;
            this.msgApi.error = false;
            this.disableAllInputs();
        },
    },
    methods: {
        async login() {
            try {
                this.loading = true;
                // POST request using axios
                let response = await loginData.get(this.formLogin);

                if (this.errorFormInput(response.data, "status")) {
                    //Elemento que recupera todos los error de validacion de campos
                    this.responseErrors = response.data.errors;

                    Object.entries(this.responseErrors).forEach(
                        ([key, value]) => {
                            this.validFieldsRegister(this.responseErrors);
                        }
                    );
                } else {
                    this.errorLogin.username = false;
                    this.errorLogin.password = false;
                    if (this.errorFormInput(response.data, "ACCESS")) {
                        this.activeForm = response.data.ACCESS == true ? 3 : 0;
                        this.setUserLoggedIn(
                            response.data.ACCESS == true ? true : false
                        );
                    } else {
                        if (
                            this.errorFormInput(response.data, "SUCCESS") &&
                            this.errorFormInput(response.data, "MESSAGE")
                        ) {
                            if (response.data.SUCCESS == "false") {
                                this.msgApi.error = true;
                                this.msgApi.message = response.data.MESSAGE;
                            }
                        }
                    }
                }
                //se settea el loadign para desaactivarlo
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        async register() {
            try {
                this.$store.dispatch("setLoading", true);
                // POST request using axios
                let response = await registerData.create(this.formRegister);
                this.errorLogin.statusApiMessage = false;

                if (this.errorFormInput(response.data, "status")) {
                    //Elemento que recupera todos los error
                    this.responseErrors = response.data.errors;

                    Object.entries(this.responseErrors).forEach(
                        ([key, value]) => {
                            this.validFieldsRegister(this.responseErrors);
                        }
                    );
                } else {
                    this.errorLogin.email = false;
                    this.errorLogin.password = false;
                    this.errorLogin.birthdate = false;

                    if (this.errorFormInput(response.data, "SUCCESS")) {
                        if (this.errorFormInput(response.data, "SUCCESS")) {
                            if (response.data.SUCCESS == "true") {
                                Vue.$toast.open({
                                    message: response.data.MESSAGE,
                                    type: "success",
                                });
                                this.$router.push({ name: "activate" });
                            } else {
                                Vue.$toast.open({
                                    message: response.data.MESSAGE,
                                    type: "error",
                                });
                            }
                        }
                    }
                }
                //se settea el loadign para desaactivarlo
                this.$store.dispatch("setLoading", false);
            } catch (error) {
                Vue.$toast.open({
                    message: $t("Forms.try_catch_api"),
                    type: "error",
                });
                
                //se settea el loadign para desaactivarlo
                this.$store.dispatch("setLoading", false);
                
            }
        },
        async activateNewUser() {
            try {
                this.loading = true;
                this.errorLogin.statusApiMessage = false;
                // POST request using axios
                let response = await activateNewUserData.create(
                    this.formActiveNewUser
                );

                if (this.errorFormInput(response.data, "status")) {
                    //Elemento que recupera todos los error
                    this.responseErrors = response.data.errors;

                    Object.entries(this.responseErrors).forEach(
                        ([key, value]) => {
                            this.validFieldsRegister(this.responseErrors);
                        }
                    );
                } else {
                    this.errorLogin.email = false;
                    this.errorLogin.Code = false;

                    if (this.errorFormInput(response.data, "SUCCESS")) {
                        if (this.errorFormInput(response.data, "SUCCESS")) {
                            if (response.data.SUCCESS == "true") {
                                this.msgApi.error = false;
                                this.msgApi.success = true;
                                this.activeForm = 0;
                            } else {
                                this.msgApi.success = false;
                                this.msgApi.error = true;
                            }
                            this.msgApi.message = response.data.MESSAGE;
                            
                            
                        }
                    }
                }
                //se settea el loadign para desaactivarlo
                this.loading = false;
            } catch (error) {
                //se settea el loadign para desaactivarlo
                this.loading = false;
                
            }
        },
        async recoveryPassword() {
            try {
                // POST request using axios
                let response = await recoveryPasswordData.create(
                    this.formRecoveryPass
                );
                this.loading = true;
                this.errorLogin.statusApiMessage = false;

                if (this.errorFormInput(response.data, "status")) {
                    //Elemento que recupera todos los error
                    this.responseErrors = response.data.errors;

                    Object.entries(this.responseErrors).forEach(
                        ([key, value]) => {
                            this.validFieldsRegister(this.responseErrors);
                        }
                    );
                } else {
                    this.errorLogin.email = false;
                    if (this.errorFormInput(response.data, "SUCCESS")) {
                        if (response.data.SUCCESS == "true") {
                            this.msgApi.error = false;
                            this.msgApi.success = true;
                            this.activeForm = 5;

                            this.makeToast(
                                "success",
                                "¡Te enviamos un enlace a tu correo, para restablecer tu contraseña!"
                            );
                        } else {
                            this.msgApi.error = false;
                            this.msgApi.error = true;
                        }
                        this.msgApi.message = response.data.MESSAGE;
                    }
                }
                //se settea el loadign para desaactivarlo
                this.loading = false;
            } catch (error) {
                
                //se settea el loadign para desaactivarlo
                this.loading = false;
            }
        },
        async validatePassword(valuePassword) {
            try {
                // POST request using axios
                let response = await validatePasswordData.get({
                    Password: valuePassword,
                });
                this.formActiveNewUser.helperBtnSend = true;
                this.responseErrors = response.data;

                Object.entries(this.responseErrors).forEach(([key, value]) => {
                    this.validFieldsRegister(this.responseErrors);
                });

                if (!response.data.count) {
                    this.errorLogin.password = false;
                    this.formActiveNewUser.helperBtnSend = false;
                    this.formResetPassword.helperBtnSend = false;
                } else {
                    this.errorLogin.password = true;
                    this.formActiveNewUser.helperBtnSend = true;
                    this.formResetPassword.helperBtnSend = true;
                }
            } catch (error) {
                
            }
        },
    },
    mounted() {},
};
</script>
